export const Divider = ({ className = '' }) => <div data-testid="atom-divider" className={`my-5 w-full border border-gray-700 ${className}`} />;
export default Divider;